import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Logger} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {UsersService} from '../../pages-services/users.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from "@ngx-translate/core";
import {ConfirmPopupComponent} from "../../components/confirm-popup/confirm-popup.component";

@Component({
    selector: 'app-settings-users',
    templateUrl: './settings-users.component.html',
    styleUrls: ['./settings-users.component.scss']
})

export class SettingsUsersComponent implements OnInit {
    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        email: string,
        firstName: string,
        lastName: string,
        password: string,
        confirmPassword?: string,
        roles: string | Array<string>,
        status: string | boolean,
        new: boolean,
    };
    searchTerm = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    roles = [
        {
            name: 'admin',
            title: 'Admin'
        }, {
            name: 'manager',
            title: 'Manager'
        }, {
            name: 'user',
            title: 'User'
        }
    ];

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    tableConfigurationLogs = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: false,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'id', title: 'ID'},
        {key: 'email', title: 'Email'},
        {key: 'firstName', title: 'First Name'},
        {key: 'lastName', title: 'Last Name'},
        {key: 'roles', title: 'Roles'},
        {key: 'status', title: 'Status'},
        {key: 'actions', title: ''}
    ];
    columnsLogs = [
        // {key: 'id', title: 'ID'},
        {key: 'email', title: 'Email'},
        {key: 'firstName', title: 'First Name'},
        {key: 'lastName', title: 'Last Name'},
        {key: 'createdAt', title: 'Date'},
        {key: 'action', title: 'Action'},
        // {key: 'ip', title: 'IP'}
    ];
    data = [];
    dataLogs = [];
    rows = [];
    logs = [];
    selected = new Set();
    selectedLocale = 'en-en';
    selectedLog;

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private usersService: UsersService,
        private modalService: BsModalService,
        private logger: Logger,
        private toasterService: ToasterService,
        private translationService: TranslateService
    ) {
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.usersService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
        this.usersService.getLogs().subscribe((dataLogs) => {
            this.dataLogs = dataLogs.sort((a, b) => {
              return <any>new Date(b.updatedAt) - <any>new Date(a.updatedAt);
            });
            this.searchLogs();
        });
    }

    localeChanged() {
        this.usersService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    editRow(row) {
        this.selectedRow = row;
        this.selectedRow.roles = (this.selectedRow.roles as string).split(',');
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    showLog(row) {
        this.selectedLog = row;
        this.searchLogs();
      }

    rowSelected(event) {
        if (event.event === 'onDoubleClick') {
            this.editRow(event.value.row);
        }
    }

    async saveUserData() {
        let sendObj = Object.assign({}, this.selectedRow);
        sendObj.status = sendObj.status === 'Active' || sendObj.status === true ? true : false;
        if (sendObj.new) {
            if (sendObj.password === sendObj.confirmPassword) {
                this.usersService
                    .create(this.selectedLocale, sendObj)
                    .subscribe(async (result) => {
                        this.getList();
                        this.toasterService.pop('success', '', await this.translationService.get('webpanel.users.user_created_message').toPromise());
                        this.editModalRef.hide();
                    }, (err) => {
                        this.toasterService.pop('error', '', err.message);
                    });
            } else {
                this.toasterService.pop('error', '', await this.translationService.get('webpanel.users.validation.passwords_not_the_same').toPromise());
                return;
            }
        } else {
            this.usersService
                .update(this.selectedLocale, sendObj)
                .subscribe((result) => {
                    this.usersService
                        .getList()
                        .subscribe(async (data) => {
                            this.data = data;
                            this.search();
                            this.toasterService.pop('success', '', await this.translationService.get('webpanel.users.user_updated_message').toPromise());
                            this.editModalRef.hide();
                        });
                });
        }
    }

    search() {
        this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
            r.email.indexOf(this.searchTerm.toLowerCase) !== -1 ||
            r.firstName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1 ||
            r.lastName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1);

        this.rows = this.rows.map((u) => ({
            ...u,
            statusTitle: u.status ? 'Active' : 'Inactive'
        }));

    }

    searchLogs() {
        if(this.selectedLog) {
            this.logs = this.dataLogs.filter((r) =>
                r.userId === this.selectedLog.id && r.user
            );
        } else {
            this.logs = this.dataLogs.filter((r) =>
              r.userId > 0 && r.user
            );
        }
      }

    addNew() {
        this.selectedRow = {
            id: null,
            email: '',
            firstName: '',
            lastName: '',
            status: true,
            password: '',
            roles: [],
            'new': true
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        let confirmMessage;
        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if(res) {
            if (this.selectedRow) {
                this.usersService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    let successMessage = await this.translationService.get('webpanel.users.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        } else {
            this.selectedRow = null;
        }
    }

    decline() {
        this.selectedRow = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/settings-users/settings-users.component.ts